import { render } from "./PaketWechseln.vue?vue&type=template&id=7b160072"
import script from "./PaketWechseln.vue?vue&type=script&lang=js"
export * from "./PaketWechseln.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__